import './global.js'
import Parse from 'parse';
import React from 'react';
import SinglePost from "./singlepost.jsx";
import { Route, Link} from "react-router-dom";
import Leftsidebar from "./Leftsidebar.jsx";
import $ from "jquery";
function time_ago(time) {

  switch (typeof time) {
    case 'number':
      break;
    case 'string':
      time = +new Date(time);
      break;
    case 'object':
      if (time.constructor === Date) time = time.getTime();
      break;
    default:
      time = +new Date();
  }
  var time_formats = [
    [60, 'seconds', 1], // 60
    [120, '1 minute ago', '1 minute from now'], // 60*2
    [3600, 'minutes', 60], // 60*60, 60
    [7200, '1 hour ago', '1 hour from now'], // 60*60*2
    [86400, 'hours', 3600], // 60*60*24, 60*60
    [172800, 'Yesterday', 'Tomorrow'], // 60*60*24*2
    [604800, 'days', 86400], // 60*60*24*7, 60*60*24
    [1209600, 'Last week', 'Next week'], // 60*60*24*7*4*2
    [2419200, 'weeks', 604800], // 60*60*24*7*4, 60*60*24*7
    [4838400, 'Last month', 'Next month'], // 60*60*24*7*4*2
    [29030400, 'months', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
    [58060800, 'Last year', 'Next year'], // 60*60*24*7*4*12*2
    [2903040000, 'years', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
    [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
    [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
  ];
  var seconds = (+new Date() - time) / 1000,
    token = 'ago',
    list_choice = 1;

  if (seconds == 0) {
    return 'Just now'
  }
  if (seconds < 0) {
    seconds = Math.abs(seconds);
    token = 'from now';
    list_choice = 2;
  }
  var i = 0,
    format;
  while (format = time_formats[i++])
    if (seconds < format[0]) {
      if (typeof format[2] == 'string')
        return format[list_choice];
      else
        return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
    }
  return time;
}


class Explorer extends React.Component {

    constructor(props) {
        super(props);

        Parse.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5", "sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw");
        Parse.serverURL = "https://parse.joelskitchen.com/parse";
        //Parse.serverURL = "https://parsetest.joelskitchen.com/parse";

        var now = new Date();

        this.state = {
            posts: {},
            users: {},
            created_at: now.getTime(),
        };
        this.queryForPostData();
        this.getSuggestedUsers();
        this.homeFetch = this.homeFetch.bind(this); 
    }
    homeFetch(event){
      // setTimeout(() => {
              this.queryForPostData();
       //  },500);
    }
    getSuggestedUsers() {
      var query = new Parse.Query('User');
      query.equalTo('isSuggested', 1);
      query.include("username");
      query.descending('_created_at');
      var self = this;
       query.find().then(function(result){
            if(result){
               self.setState({users: result});
            } else {
                console.log("No user found");
            }
        }, function(error){
                console.error("Error loading post Error: " + error);
        });

    }

    queryForPostData() {

        var query = new Parse.Query('Photo');
        query.include("user");
        query.include("image");
        query.include("thumbnail");
        query.include("likeCountNew");
        query.include("saveCount");
        query.include("commentcount");
        query.include("_created_at");
        query.include("createdAt");
        query.exists("user");
        query.descending("createdAt");
        query.limit(100);

        var self = this;

        query.find().then(function(result){
            if(result){
                self.setState({posts: result});
            } else {
                console.log("No post found");
            }
        }, function(error){
                console.error("Error loading post Error: " + error);
        });
    }
    renderUsers()
    {
      let buffer = [];

        if (this.state.users)
        {
            for (var i = 0; i < this.state.users.length; i++)
            {
                var user = this.state.users[i];
                var profile_picture= user.get("profilePictureSmall").url();
                if(profile_picture!==undefined)
                {
                  profile_picture=profile_picture;
                }else
                {
                  profile_picture="/images/menu-account.svg";
                }
                buffer.push(
                   <li className='menu'  key={69*i}>
                        <a href={'/user/'+user.get("displayUsername")}  title={user.get("displayUsername")} className='media'>
                          <div className="media-left">

                            <img src={profile_picture} className='mr-2' width="40px" height="40px" alt="itsallgoodvegan"/>
                          </div>
                          <div className="media-body">
                            <h6 className="mt-0">{user.get("displayUsername")}</h6>
                            <span>{user.get("displayName")}</span>
                          </div>
                        </a>
                      </li>
                  
                );
            }
        }

        return (  <ul className='list_grp'>
                {buffer}
                </ul>
               
        );

    }

   /* renderPosts()
    {
        

        let buffer = [];

        if (this.state.posts)
        {
            for (var i = 0; i < this.state.posts.length; i++)
            {
                var post = this.state.posts[i];
            
                buffer.push(<div className='card_box' key={69*i}>
                    <SinglePost postData={post}/>
                </div>);
            }
        }

        return ( <div className='list_group'>
                {buffer}
                </div>
        );
    }*/

    render() {

 
    
    return (
      
      <section className='post_list'> 
        <div className='container'>
          <div className='inner'>
            <nav className='sidebar'>
              <Leftsidebar/>
            </nav>
            <main className='listing sticky_app_btn'>
                {/*this.renderPosts()*/}


              
            </main>
          </div>
        </div>
        
      </section>      
    );
  }
}

export default Explorer;



// WEBPACK FOOTER //
// ./src/explorer.jsx